import { DictionaryKey } from "../../../param/dictionaries";
import { frypanDictionary } from "../../data/frypan";
import { dataSource } from "../../dictionaryWorker";

type SortedTable = Partial<Record<string, Record<string, string[]>>>;
type DictionaryTable = Partial<Record<string, Record<string, boolean>>>;

const sortedTable: SortedTable = {};
const dictionaryTable: DictionaryTable = {};

export const createSortedTable = (dictionary: (DictionaryKey | "frypan")[]) => {
  const words = dictionary.includes("frypan")
    ? frypanDictionary
    : dataSource.getArray(dictionary as DictionaryKey[]);
  if (!words) {
    return {};
  }
  const key = dictionary.sort().join(",");
  if (sortedTable[key]) {
    return sortedTable[key];
  }

  const table: Record<string, string[]> = {};

  for (const word of words) {
    const key = word.split("").sort().join("");
    table[key] = table[key] ?? [];
    table[key].push(word);
  }
  return (sortedTable[key] = table);
};

export const createDictionaryTable = (
  dictionary: (DictionaryKey | "frypan")[]
) => {
  const key = dictionary.sort().join(",");
  if (dictionaryTable[key]) {
    return dictionaryTable[key];
  }

  const words = dictionary.includes("frypan")
    ? frypanDictionary
    : dataSource.getArray(dictionary as DictionaryKey[]);
  if (!words) {
    return {};
  }

  const table: Record<string, boolean> = {};

  for (const word of words) {
    table[word] = true;
  }
  return (dictionaryTable[key] = table);
};
